// extracted by mini-css-extract-plugin
export default {"meinian-shop-top":"index_meinian-shop-top__E8lKD"};